import {graphql, useStaticQuery} from 'gatsby';

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          lang
          title
          description
          siteUrl
          image
          og {
            title
            description
            image
            url
            type
            site_name
            locale
          }
        }
      }
    }
  `);

  return data.site.siteMetadata;
};
